<div class="showcase">
  <!-- DATEPICKER -->
  <span class="component-label" (click)="mpDatePickerOpened = !mpDatePickerOpened">
    {{ 'SHOWCASE.DATEPICKER.LABEL' | translate }}
    <span *ngIf="!mpDatePickerOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpDatePickerOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpDatePickerOpened">
    <span class="interactive-element">
      <app-mp-date-picker [disabled]="true"
        [(dateValue)]="datePickerValue"
        [label]="'SHOWCASE.DATEPICKER.WITH_VALUE'">
      </app-mp-date-picker>
      <span
        class="result-element">{{ 'SHOWCASE.DATEPICKER.RESULT' | translate }}{{ datePickerValue.date | date:'dd/MM/yyyy' }}</span>
    </span>
    <span class="interactive-element">
       <app-mp-date-picker [isReadOnly]="true"
         [(dateValue)]="datePickerValue">
      </app-mp-date-picker>
      <span
        class="result-element">{{ 'SHOWCASE.DATEPICKER.RESULT' | translate }}{{ datePickerFormControl?.value | date:'dd/MM/yyyy' }}</span>
    </span>
    <span class="interactive-element">
      <app-mp-date-picker [dateFormControl]="datePickerFormControl" [label]="'SHOWCASE.DATEPICKER.WITH_FORMCONTROL'">
      </app-mp-date-picker>
      <span
        class="result-element">{{ 'SHOWCASE.DATEPICKER.RESULT' | translate }}{{ datePickerFormControl?.value | date:'dd/MM/yyyy' }}</span>
    </span>
    <span class="interactive-element">
      <app-mp-date-picker [timeIntervalAllowed]="true"
        [timeFormControl]="hoursDatePickerFormControl"
        [dateFormControl]="datePickerWithHoursFormControl"
        [label]="'SHOWCASE.DATEPICKER.WITH_HOURS'">
      </app-mp-date-picker>

      <div class="result-element">
        {{ 'SHOWCASE.DATEPICKER.RESULT' | translate }}
        {{ datePickerWithHoursFormControl?.value | date:'dd/MM/yyyy' }}
        <ng-container *ngIf="hoursDatePickerFormControl?.value">
          <ng-container *ngIf="hoursDatePickerFormControl.value.start">
            {{ hoursDatePickerFormControl.value.start }}
          </ng-container>
          <ng-container
            *ngIf="hoursDatePickerFormControl.value.start || hoursDatePickerFormControl.value.end"> - </ng-container>
          <ng-container *ngIf="hoursDatePickerFormControl.value.end">
            {{ hoursDatePickerFormControl.value.end }}
          </ng-container>
        </ng-container>
      </div>
    </span>
    <span class="interactive-element">
      <app-mp-date-picker
        [dateIntervalAllowed]="true"
        [dateFormControl]="datePickerWithIntervalFormControl">
      </app-mp-date-picker>
      <div class="result-element">
        {{ 'SHOWCASE.DATEPICKER.START' | translate }}
        {{ datePickerWithIntervalFormControl?.value?.start | date:'dd/MM/yyyy' }}
        {{ 'SHOWCASE.DATEPICKER.END' | translate }}
        {{ datePickerWithIntervalFormControl?.value?.end | date:'dd/MM/yyyy' }}
      </div>
    </span>
    <span class="interactive-element">
      <app-mp-date-picker
        [dateIntervalAllowed]="true"
        [timeIntervalAllowed]="true"
        [dateFormControl]="datePickerEverythingFormControl"
        [timeFormControl]="hoursDatePickerEverythingFormControl">
      </app-mp-date-picker>
      <div class="result-element">
        <div>
          <div *ngIf="datePickerEverythingFormControl?.value">
            {{ 'SHOWCASE.DATEPICKER.START' | translate }}
            {{ datePickerEverythingFormControl?.value?.start | date:'dd/MM/yyyy' }}
            {{ 'SHOWCASE.DATEPICKER.END' | translate }}
            {{ datePickerEverythingFormControl?.value?.end | date:'dd/MM/yyyy' }}
          </div>
          <div *ngIf="hoursDatePickerEverythingFormControl?.value">
            <ng-container *ngIf="hoursDatePickerEverythingFormControl.value.start">
              {{ hoursDatePickerEverythingFormControl.value.start }}
            </ng-container>
            <ng-container
              *ngIf="hoursDatePickerEverythingFormControl.value.start || hoursDatePickerEverythingFormControl.value.end"> - </ng-container>
            <ng-container *ngIf="hoursDatePickerEverythingFormControl.value.end">
              {{ hoursDatePickerEverythingFormControl.value.end }}
            </ng-container>
          </div>
        </div>
      </div>
    </span>
  </div>

  <!-- HOURPICKER -->
  <span class="component-label" (click)="mpHourPickerOpened = !mpHourPickerOpened">
    {{ 'SHOWCASE.HOURPICKER.LABEL' | translate }}
    <span *ngIf="!mpHourPickerOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpHourPickerOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpHourPickerOpened">
    <span class="interactive-element">
      <app-mp-hour-picker [disabled]="true" [(inputValue)]="hourPickerValue" [label]="'SHOWCASE.HOURPICKER.WITH_VALUE'">
      </app-mp-hour-picker>
      <span class="result-element">{{ 'SHOWCASE.HOURPICKER.RESULT' | translate }}{{ hourPickerValue }}</span>
    </span>
    <span class="interactive-element">
      <app-mp-hour-picker [formControlField]="hourPickerFormControl" [label]="'SHOWCASE.HOURPICKER.WITH_FORMCONTROL'">
      </app-mp-hour-picker>
      <span
        class="result-element">{{ 'SHOWCASE.HOURPICKER.RESULT' | translate }}{{ hourPickerFormControl?.value }}</span>
    </span>
  </div>

  <!-- CHECKBOX -->
  <span class="component-label" (click)="mpCheckboxOpened = !mpCheckboxOpened">
    {{ 'SHOWCASE.CHECKBOX.LABEL' | translate }}
    <span *ngIf="!mpCheckboxOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpCheckboxOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpCheckboxOpened">
    <mp-checkbox [label]="'SHOWCASE.CHECKBOX.DISABLED'" [size]="'small'" [disabled]="true"
      [checked]="true"></mp-checkbox>
    <mp-checkbox [label]="'SHOWCASE.CHECKBOX.WITH_LABEL'" [size]="'medium'" [(value)]="checkBoxValue"
      [checked]="checkBoxValue"></mp-checkbox>
    <mp-checkbox [label]="'SHOWCASE.CHECKBOX.ACCENT'" [color]="'accent'" [checked]="true"></mp-checkbox>
  </div>

  <!-- BUTTON -->
  <span class="component-label" (click)="mpButtonOpened = !mpButtonOpened">
    {{ 'SHOWCASE.BUTTON.LABEL' | translate }}
    <span *ngIf="!mpButtonOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpButtonOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpButtonOpened">
    <app-mp-button [color]="'accent'" [size]="'small'" [label]="'SHOWCASE.BUTTON.SMALL_SIZE_BUTTON'"
      (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')"></app-mp-button>
    <app-mp-button [color]="'warning'" [label]="'SHOWCASE.BUTTON.MEDIUM_SIZE_BUTTON'"
      (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')"></app-mp-button>
    <app-mp-button [size]="'large'" [label]="'SHOWCASE.BUTTON.LARGE_SIZE_BUTTON'"
      (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')"></app-mp-button>
    <app-mp-button [size]="'icon'" [label]="'SHOWCASE.BUTTON.ICON_SIZE_BUTTON'"
      (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')"></app-mp-button>
    <app-mp-button [size]="'icon'" [mpTooltip]="'SHOWCASE.BUTTON.ICON_ONLY_BUTTON'" [mpTooltipPosition]="'right'"
      [faIcon]="'fas fa-plus'" (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')"></app-mp-button>
    <app-mp-button [label]="'SHOWCASE.BUTTON.DISABLED_BUTTON'" [disabled]="true"
      (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')"></app-mp-button>
    <app-mp-button [color]="'negative'" [faIcon]="'fas fa-sliders-h'" [faIconPosition]="'after'"
      [label]="'SHOWCASE.BUTTON.NEGATIVE_BUTTON'"
      (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')"></app-mp-button>
    <span class="limited-width-container">
      <app-mp-button [faIcon]="'fas fa-ellipsis-h'" [label]="'SHOWCASE.BUTTON.ELLIPSIS_BUTTON'"
        (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')"></app-mp-button>
    </span>
    <app-mp-button [color]="'accent'" [size]="'small'" [label]="'SHOWCASE.BUTTON.LOADING_BUTTON'"
      (buttonClicked)="openSnackBarInfo('SHOWCASE.BUTTON.CLICKED')" [isLoading]="isLoading"></app-mp-button>
  </div>

  <!-- SNACKBAR -->
  <span class="component-label" (click)="mpSnackbarOpened = !mpSnackbarOpened">
    {{ 'SHOWCASE.SNACKBAR.LABEL' | translate }}
    <span *ngIf="!mpSnackbarOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpSnackbarOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpSnackbarOpened">
    <app-mp-button [label]="'SHOWCASE.SNACKBAR.INFO_BUTTON'"
      (buttonClicked)="openSnackBarInfo()"></app-mp-button>
    <app-mp-button [label]="'SHOWCASE.SNACKBAR.WARNING_BUTTON'"
      (buttonClicked)="openSnackBarWarning()"></app-mp-button>
    <app-mp-button [label]="'SHOWCASE.SNACKBAR.SUCCESS_BUTTON'"
      (buttonClicked)="openSnackBarSuccess()"></app-mp-button>
    <app-mp-button [label]="'SHOWCASE.SNACKBAR.ERROR_BUTTON'"
      (buttonClicked)="openSnackBarError()"></app-mp-button>
    <app-mp-button [label]="'SHOWCASE.SNACKBAR.INFO_BUTTON_WITH_LINK'"
      (buttonClicked)="openSnackBarInfoWithLink()"></app-mp-button>
  </div>

  <!-- TOOLTIP -->
  <span class="component-label" (click)="mpTooltipOpened = !mpTooltipOpened">
    {{ 'SHOWCASE.TOOLTIP.LABEL' | translate }}
    <span *ngIf="!mpTooltipOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpTooltipOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpTooltipOpened">
    <span class="interactive-element" [mpTooltip]="'SHOWCASE.TOOLTIP.MESSAGE_ABOVE'"
      [mpTooltipPosition]="'above'">{{ 'SHOWCASE.TOOLTIP.TOUCH_ME' | translate }}</span>
    <span class="interactive-element"
      [mpTooltip]="'SHOWCASE.TOOLTIP.MESSAGE_BELOW'">{{ 'SHOWCASE.TOOLTIP.TOUCH_ME' | translate }}</span>
    <span class="interactive-element" [mpTooltip]="'SHOWCASE.TOOLTIP.MESSAGE_LEFT'"
      [mpTooltipPosition]="'left'">{{ 'SHOWCASE.TOOLTIP.WAIT' | translate }}</span>
    <span class="interactive-element" [mpTooltip]="'SHOWCASE.TOOLTIP.MESSAGE_RIGHT'"
      [mpTooltipPosition]="'right'">{{ 'SHOWCASE.TOOLTIP.STOP' | translate }}</span>
  </div>

  <!-- INPUT -->
  <span class="component-label" (click)="mpInputOpened = !mpInputOpened">
    {{ 'SHOWCASE.INPUT.LABEL' | translate }}
    <span *ngIf="!mpInputOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpInputOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpInputOpened">
    <span class="interactive-element">
      <app-mp-input [formControlField]="inputStringFormControl"
        [label]="'SHOWCASE.INPUT.WITH_FORM_CONTROL'"></app-mp-input>
      <span class="result-element">{{ 'SHOWCASE.INPUT.RESULT' | translate }}{{ inputStringFormControl.value }}</span>
    </span>
    <span class="interactive-element">
      <app-mp-input [(inputValue)]="inputNumberValue" [type]="'number'"
        [label]="'SHOWCASE.INPUT.WITH_VALUE'"></app-mp-input>
      <span class="result-element">{{ 'SHOWCASE.INPUT.RESULT' | translate }}{{ inputNumberValue }}</span>
    </span>
    <span class="interactive-element">
      <app-mp-input [formControlField]="inputValueChangeFormControl"
        (inputValueChange)="openSnackBarInfo('SHOWCASE.INPUT.VALUE_CHANGED')"
        [label]="'SHOWCASE.INPUT.VALUE_CHANGE'"></app-mp-input>
      <span
        class="result-element">{{ 'SHOWCASE.INPUT.RESULT' | translate }}{{ inputValueChangeFormControl.value }}</span>
    </span>
    <span class="interactive-element">
      <app-mp-input [inputValue]="'o7'"
        [label]="'SHOWCASE.INPUT.NOP'"
        [disabled]="true"></app-mp-input>
    </span>
    <span class="interactive-element">
      <app-mp-input
        [(inputValue)]="inputWithIconValue"
        [label]="'SHOWCASE.INPUT.WITH_ICON'"
        [faIcon]="'fal fa-search'"
        (iconClicked)="inputIconClicked()">
      </app-mp-input>
      <span class="result-element">{{ 'SHOWCASE.INPUT.RESULT' | translate }}{{ inputWithIconValue }}</span>
    </span>
    <span class="interactive-element">
      <app-mp-input
        [(inputValue)]="inputWithIconValue"
        [label]="'SHOWCASE.INPUT.READONLY'"
        [faIcon]="'fal fa-search'"
        [isReadOnly]="true"
        (iconClicked)="inputIconClicked()">
      </app-mp-input>
      <span class="result-element">{{ 'SHOWCASE.INPUT.RESULT' | translate }}{{ inputWithIconValue }}</span>
    </span>
  </div>

  <!-- AUTOCOMPLETE -->
  <span class="component-label" (click)="mpAutocompleteOpened = !mpAutocompleteOpened">
    {{ 'SHOWCASE.AUTOCOMPLETE.LABEL' | translate }}
    <span *ngIf="!mpAutocompleteOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpAutocompleteOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpAutocompleteOpened">
    <span class="interactive-element">
      <app-mp-autocomplete
        [(inputValue)]="autocompleteValue"
        [autocompleteBehavior]="autocompleteChanged.bind(this)"
        [label]="'SHOWCASE.AUTOCOMPLETE.WITH_VALUE'">
      </app-mp-autocomplete>
    </span>
    <span class="interactive-element">
          <app-mp-autocomplete
            [(inputValue)]="autocompleteValue"
            [autocompleteBehavior]="autocompleteChanged.bind(this)"
            [label]="'SHOWCASE.AUTOCOMPLETE.WITH_VALUE'"
            [isReadOnly]="true">
          </app-mp-autocomplete>
        </span>
  </div>

  <!-- TEXTAREA -->
  <span class="component-label" (click)="mpTextareaOpened = !mpTextareaOpened">
    {{ 'SHOWCASE.TEXTAREA.LABEL' | translate }}
    <span *ngIf="!mpTextareaOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpTextareaOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpTextareaOpened">
    <span class="interactive-element">
      <app-mp-textarea [formControlField]="textareaFormControl"
        [label]="'SHOWCASE.TEXTAREA.WITH_FORM_CONTROL'"></app-mp-textarea>
    </span>
    <span class="interactive-element" style="width: 255px;">
      <app-mp-textarea [(textareaValue)]="textareaValue"
        [sizeLocked]="true"
        [disabled]="true"
        [rows]="4"
        [label]="'SHOWCASE.TEXTAREA.WITH_VALUE'"></app-mp-textarea>
    </span>
  </div>

  <!-- CONTEXTUAL MENU -->
  <span class="component-label" (click)="mpContextualMenuOpened = !mpContextualMenuOpened">
    {{ 'SHOWCASE.CONTEXTUAL_MENU.LABEL' | translate }}
    <span *ngIf="!mpContextualMenuOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpContextualMenuOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpContextualMenuOpened">
    <app-mp-button [size]="'medium'"
      [label]="'SHOWCASE.CONTEXTUAL_MENU.CONTEXTUAL_MENU'"
      [faIcon]="'fas fa-ellipsis-v'"
      [faIconPosition]="'after'"
      [mpContextualMenu]="contextualMenu"
      [mpContextualMenuData]="{index: 42}">
    </app-mp-button>
    <ng-template #contextualMenu let-data>
      <div class="contextual-menu">
        <span class="contextual-menu-option"
          (click)="openSnackBarInfo('SHOWCASE.CONTEXTUAL_MENU.CLICKED')">{{ 'SHOWCASE.CONTEXTUAL_MENU.CLICKED' | translate }}</span>
        <span class="contextual-menu-option"
          (click)="openSnackBarInfo('SHOWCASE.CONTEXTUAL_MENU.SHOWED_PARAMS', data)">{{ 'SHOWCASE.CONTEXTUAL_MENU.SHOW_PARAMS' | translate }}</span>
      </div>
    </ng-template>
  </div>

  <!-- MODAL -->
  <span class="component-label" (click)="mpModalOpened = !mpModalOpened">
    {{ 'SHOWCASE.MODAL.LABEL' | translate }}
    <span *ngIf="!mpModalOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpModalOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpModalOpened">
    <app-mp-button [size]="'medium'"
      [label]="'SHOWCASE.MODAL.OPEN_MODAL'"
      [mpOpenModal]="modal"
      [mpModalBackdrop]="true"
      [mpClickableModalBackdrop]=" true">
    </app-mp-button>
    <ng-template #modal>
      <div class="mock-modal">
        <span>{{ 'SHOWCASE.MODAL.CONTENT' | translate }}</span>
      </div>
    </ng-template>

    <app-mp-button
      [size]="'medium'"
      [label]="'SHOWCASE.MODAL.OPEN_MODAL_WITHOUT_BACKDROP'"
      [mpOpenModal]="modal2">
    </app-mp-button>
    <ng-template #modal2>
      <div class="mock-modal">
        <span>{{ 'SHOWCASE.MODAL.CONTENT' | translate }}</span>
      </div>
    </ng-template>
  </div>

  <!-- SELECT -->
  <span class="component-label" (click)="mpSelectOpened = !mpSelectOpened">
    {{ 'SHOWCASE.SELECT.LABEL' | translate }}
    <span *ngIf="!mpSelectOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpSelectOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpSelectOpened">
    <span class="interactive-element">
      <app-mp-select [options]="['MAIS', 'NON!']"
        [label]="'SHOWCASE.SELECT.STRING_SELECT'"
        [(inputValue)]="selectValueString">
      </app-mp-select>
    </span>

    <span class="interactive-element">
      <app-mp-select [options]="[{name: 'ça'}, {name: 'marche!'}]"
        [label]="'SHOWCASE.SELECT.OBJECT_SELECT'"
        [optionLabelBehavior]="getObjectOptionLabel"
        [formControlField]="selectFormControl"
        (inputValueChange)="openSnackBarInfo('SHOWCASE.SELECT.CHANGED')">
      </app-mp-select>
    </span>

    <span class="interactive-element">
      <span style=" position:relative; width: 200px">
        <app-mp-select [options]="['Chocolat', 'Fraise', 'Framboise', 'Orange', 'Citron']"
          [label]="'SHOWCASE.SELECT.MULTI_SELECT'"
          [multiple]="true"
          [(inputValue)]="selectValueMultiple">
        </app-mp-select>
      </span>
      <span class="result-element">{{ 'SHOWCASE.INPUT.RESULT' | translate }}{{ selectValueMultiple.toString() }}</span>
    </span>

    <span class="interactive-element">
      <app-mp-select
        [options]="[{id: 1, name: 'Chocolat'}, {name: 'Fraise'}, {name: 'Framboise'}, {name: 'Orange'}, {name: 'Citron'}]"
        [label]="'SHOWCASE.SELECT.MULTIPLE_OBJECT'"
        [multiple]="true"
        [(inputValue)]="selectMultipleObject"
        [optionLabelBehavior]="getObjectOptionLabel"
        [isSameOption]="isSameAutocompleteOption">
      </app-mp-select>
    </span>

    <span class="interactive-element">
      <app-mp-select
        [options]="[{id: 1, name: 'Chocolat'}, {name: 'Fraise'}, {name: 'Framboise'}, {name: 'Orange'}, {name: 'Citron'}]"
        [label]="'SHOWCASE.SELECT.MULTIPLE_OBJECT'"
        [multiple]="true"
        [isReadOnly]="true"
        [(inputValue)]="selectMultipleObject"
        [optionLabelBehavior]="getObjectOptionLabel"
        [isSameOption]="isSameAutocompleteOption"
        [faIcon]="'fa-sharp fa-regular fa-candy-bar'">>
      </app-mp-select>
    </span>

  </div>

  <span class="component-label" (click)="mpSelectAutocompleteOpened = !mpSelectAutocompleteOpened">
    {{ 'SHOWCASE.SELECT_AUTOCOMPLETE.LABEL' | translate }}
    <span *ngIf="!mpSelectAutocompleteOpened"><i class="fas fa-caret-down"></i></span>
    <span *ngIf="mpSelectAutocompleteOpened"><i class="fas fa-caret-up"></i></span>
  </span>
  <div class="component-line" *ngIf="mpSelectAutocompleteOpened">
    <span class="interactive-element">
      <app-mp-select [options]="selectAutocompleteOptionsShown"
        [label]="'SHOWCASE.SELECT_AUTOCOMPLETE.AUTOCOMPLETE'"
        [autocompleteSearchLabel]="'GLOBAL.SEARCH'"
        [(inputValue)]="autoCompleteValueString"
        [autocompleteBehavior]="selectAutocompleteChanged.bind(this)">
      </app-mp-select>
    </span>

    <span class="interactive-element">
      <app-mp-select [options]="selectAutocompleteMultipleOptionsShown"
        [label]="'SHOWCASE.SELECT_AUTOCOMPLETE.AUTOCOMPLETE_MULTIPLE'"
        [multiple]="true"
        [autocompleteSearchLabel]="'GLOBAL.SEARCH'"
        [(inputValue)]="autoCompleteMultiple"
        [autocompleteBehavior]="selectAutocompleteMultipleChanged.bind(this)">
      </app-mp-select>
    </span>

    <span class="interactive-element">
      <app-mp-select [options]="selectAutocompleteMultipleObjectOptionsShown"
        [label]="'SHOWCASE.SELECT_AUTOCOMPLETE.AUTOCOMPLETE_MULTIPLE_OBJECT'"
        [multiple]="true"
        [autocompleteSearchLabel]="'GLOBAL.SEARCH'"
        [(inputValue)]="autoCompleteMultipleObject"
        [optionLabelBehavior]="getObjectOptionLabel"
        [autocompleteBehavior]="selectAutocompleteMultipleOptionsChanged.bind(this)"
        [isSameOption]="isSameAutocompleteOption">
      </app-mp-select>
    </span>

    <span class="interactive-element" style=" position:relative; width: 200px">
      <app-mp-select
        [options]="selectAsyncOptions"
        [isReadOnly]="true"
        [label]="'SHOWCASE.SELECT_AUTOCOMPLETE.AUTOCOMPLETE_MULTIPLE_OBJECT_ASYNC'"
        [multiple]="true"
        [autocompleteSearchLabel]="'GLOBAL.SEARCH'"
        [(inputValue)]="selectAsyncMultipleObject"
        [optionLabelBehavior]="getAppointmentOptionLabel"
        [fetchDataBehaviorAsync]="asyncSelectDataFetch.bind(this)"
        [isSameOption]="isSameAutocompleteOption">
      </app-mp-select>
    </span>
  </div>
</div>
